import { Stack, Typography } from '@mui/material';
import dayjs from 'dayjs';
import { DynamicIcon, FormLabel, PartnerTimeZoneTooltip } from 'src/components';
import { SidePanelRowProps } from 'src/graphql/entities/side-panel-personalization';
import { DATE_FORMAT } from 'src/pages/Settings/users/const';
import { useConversationEntity } from './conversation-entity-context';

export const CreatedRow = (_props: SidePanelRowProps) => {
  const { conversation } = useConversationEntity();

  return (
    <Stack direction="row" alignItems="center" px={2}>
      <FormLabel label="Created" />
      <Stack width="100%" gap={1} direction="row" alignItems="center" px="0.5rem">
        <DynamicIcon
          name="calendar"
          library="lucide"
          sx={{
            color: (theme) => theme.palette.custom.OV.sys.onSurfaceVariant,
            alignSelf: 'center',
          }}
        />
        <PartnerTimeZoneTooltip
          tooltipProps={{ placement: 'left' }}
          date={conversation.createdAt}
          partnerId={conversation.partnerId}
        >
          <Typography fontSize="0.8rem" variant="body2">
            {dayjs(conversation.createdAt).format(DATE_FORMAT)}
          </Typography>
        </PartnerTimeZoneTooltip>
      </Stack>
    </Stack>
  );
};
